export default __webpack_public_path__ + "static/media/zh_TW.08f44c13.svg";